
import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

interface NavbarMobileMenuProps {
  handleSectionClick: (sectionId: string) => void;
  solutionsOpen: boolean;
  setSolutionsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavbarMobileMenu = ({ 
  handleSectionClick, 
  solutionsOpen, 
  setSolutionsOpen, 
  setMobileMenuOpen 
}: NavbarMobileMenuProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="absolute top-full left-0 w-full bg-white dark:bg-gray-800 shadow-subtle p-4 md:hidden animate-fade-in">
      <nav className="flex flex-col gap-4">
        <button 
          className="px-4 py-2 text-sm font-medium hover:bg-muted rounded-md transition-colors text-left dark:text-gray-200 dark:hover:bg-gray-700"
          onClick={() => handleSectionClick("about")}
        >
          {t('about')}
        </button>
        
        {/* Mobile Solutions dropdown */}
        <div className="px-4 py-2">
          <button 
            className="flex items-center justify-between w-full text-sm font-medium hover:text-primary transition-colors dark:text-gray-200"
            onClick={() => setSolutionsOpen(!solutionsOpen)}
          >
            {t('solutions')}
            <ChevronDown className={`w-4 h-4 transition-transform ${solutionsOpen ? 'rotate-180' : ''}`} />
          </button>
          
          {solutionsOpen && (
            <div className="mt-2 pl-4 border-l-2 border-gray-100 dark:border-gray-700">
              <Link 
                to="/arbitrinity" 
                className="block py-2 text-sm hover:text-primary transition-colors dark:text-gray-300"
                onClick={() => {
                  setSolutionsOpen(false);
                  setMobileMenuOpen(false);
                }}
              >
                Arbitrinity
              </Link>
            </div>
          )}
        </div>
        
        <button 
          className="px-4 py-2 text-sm font-medium hover:bg-muted rounded-md transition-colors text-left dark:text-gray-200 dark:hover:bg-gray-700"
          onClick={() => handleSectionClick("contact")}
        >
          {t('contact')}
        </button>
      </nav>
    </div>
  );
};

export default NavbarMobileMenu;
